export default {
  header: 'Congrats, cheerie is your new search engine!',
  subtitle: 'Let’s Change The World Together',
  msg: `Every search you make will directly contribute to helping no kill
          animal rescue shelters around the world.`,
};
